import { HTTP } from "../../../../services/api-service.js";
import commonObj from "../../../../services/common.js";
var common = new commonObj();
var baseUrl = common.baseURL;
var tableName = "BusinessEntity";

const businessEntityStore = {
  namespaced: true,
  state: {
    totalItem: 0,
    q: {
      tableNeedQuery: tableName,
      isOuterJoin: false,
      searchCriteria: "",
      orderBy: "",
      take: 1000000,
      skip: 0
    },
    currentSelectedPage: 0,
    fullEntityList: []
  },
  mutations: {
    setFullEntityList(state, data) {
      const uniqueData = data.reduce((acc, current) => {
        if (!acc[current.EntNum]) {
          acc[current.EntNum] = current;
        }
        return acc;
      }, {});
      state.fullEntityList = Object.values(uniqueData);
    }
  },
  actions: {
    getBusinessEntityList({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/businessEntity/getinvlist", param)
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getFullBEList({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/entity/EntityList",
          JSON.stringify({
            entType: param.entType,
            slsManCode: param.slsManCode
          })
        )
          .then(response => {
            commit("setFullEntityList", response.data.Data);
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getBusinessEntity({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/entity/GetEntity",
          JSON.stringify({
            entityNum: param.entityNum,
            entType: param.entType
          })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    saveBusinessEntity({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/entity/SaveEntity",
          JSON.stringify({ entity: param.Entity })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    deleteBusinessEntity({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/entity/DeleteEntity",
          JSON.stringify({ entNum: param.entNum })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    exportFile({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/mm/export", state.q, { responseType: "blob" })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getAllLocCountry({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/entity/EntityLocationList",
          JSON.stringify({
            entNum: param.entNum,
            lang: param.lang,
            slsManCode: param.slsManCode
          })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getAllVendorCategory({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/entity/VendorCateList")
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getDistrict({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/district/DistrictList",
          JSON.stringify({ CountryCode: param.CountryCode })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getArea({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/district/AreaList",
          JSON.stringify({
            CountryCode: param.CountryCode,
            DistrictCode: param.DistrictCode
          })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    saveBusinessEntityLocation({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/entity/SaveEntityLoc",
          JSON.stringify({ entityLoc: param.entityLoc })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getAllSalesmanList({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/entity/SalesmenList")
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    }
  }
};
export default businessEntityStore;
